import { render, staticRenderFns } from "./chat-toolbar.vue?vue&type=template&id=3608a490&scoped=true&"
import script from "./chat-toolbar.vue?vue&type=script&lang=js&"
export * from "./chat-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./chat-toolbar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chat-toolbar.vue?vue&type=style&index=1&id=3608a490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608a490",
  null
  
)

export default component.exports